import AnimatedButton from "../buttons/AnimatedButton";

const DiscoverResources: React.FC<any> = ({ currentContent }) => {
  return (
    <div className="header-content-column">
      <div className="limited-heading-set display">
        <div className="tagline-heading">{currentContent.tagline}</div>
        <div className="heading-set-3">
          <h1 className="heading-1">{currentContent.heading}</h1>
          <div className="paragraph-large" dangerouslySetInnerHTML={{ __html: currentContent.paragraph }}></div>
          <AnimatedButton buttonText={currentContent.buttonText} />
        </div>
      </div>
    </div>
  );
};

export default DiscoverResources;